import React from 'react'
import { Box, Flex, Text } from '@chakra-ui/react'
import ChevronDownIcon from '_app/components/Icons/ChevronDownIcon'

interface MobileDropdownButtonProps {
  text: React.ReactNode;
  isOpen: boolean;
  onToggle: () => void;
  withBorder?: boolean;
}

const MobileDropdownButton: React.FC<MobileDropdownButtonProps> = ({
  isOpen,
  onToggle,
  text,
  withBorder,
}) => {
  return (
    <Box
      as="button"
      textAlign="left"
      px={0}
      onClick={onToggle}
      borderWidth={0}
      borderColor="mercury"
      borderTopWidth={withBorder ? '1px' : 0}
      borderBottomWidth={withBorder ? '1px' : 0}
      p="0.5rem 1rem 1rem 1rem"
      minW="unset"
      flex={1}
      height={12}
      minHeight={12}
      bg={isOpen ? 'main' : 'white'}
      width="100%"
    >
      <Flex justifyContent="space-between" alignItems="center">
        <Text as="span" textStyle="body">
          {text}
        </Text>
        <ChevronDownIcon
          sx={{
            transform: `rotate(${isOpen ? 180 : 0}deg)`,
            transition: 'transform 0.2s',
          }}
        />
      </Flex>
    </Box>
  )
}

export default MobileDropdownButton
